import Includings from './Includings';
import React from 'react';
import Head from 'next/head';
function content(props) {
  return (
    <>
      <div className="bg-white py-23 pt-0 md:pt-10">
        <div className="container">
          <div>
            <p
              ref={props.refProp}
              className="part-margin-scroll text-purple text-16 md:text-24 font-bold mt-20 mb-15 leading-7 uppercase md:normal-case"
            >
              Our Paid Advertising Service Includes
            </p>
            <Includings
              content={[
                {
                  title: 'Guaranteed Leads',
                  answer:
                    'We guarantee you will have leads or purchases, depending on your business goals. If there is no result, we return the service management fee.',
                },
                {
                  title: 'Campaign development & strategy',
                  answer:
                    'We create the advertising strategy considering the effectiveness of platforms and tools for your business and set up ad campaigns.',
                },
                {
                  title: 'Keyword research and selection',
                  answer: 'We do keyword research and pick the most relevant keywords used by potential customers to find your products or services.',
                },
                {
                  title: 'Industry analysis',
                  answer:
                    'We even do industry analysis, which allows us to find the competitive advantages/disadvantages and better understand ways to attract your target audience.',
                },
                { title: 'Ad campaign copywriting', answer: 'We create ad copies, where we pay the main attention to creativity and CTA messages.' },
                {
                  title: 'Ad Banners Creation',
                  answer:
                    'We also create two banner creatives for Display advertising, which are fully animated and meet the parameters for having effective HTML5 banners in ads platforms.',
                },
                {
                  title: 'Ad Performance Testing',
                  answer:
                    'No one can guarantee that the created texts and visuals will work immediately, so we do continuous AB testing to find the most optimal options to increase ads performance.',
                },
                {
                  title: 'Google analytics integration & goal tracking',
                  answer:
                    'Without measurability and data analysis, our actions will not succeed, so we integrate Google Analytics, set goals, and monitor progress throughout.',
                },
                {
                  title: 'Strategic bid management',
                  answer:
                    "We don't want you to waste a single penny more, so we use smart bidding technologies to get the best possible results for the lowest price.",
                },
                {
                  title: 'Remarketing',
                  answer:
                    'Through remarketing, we will try to recapture valuable users, enhance brand awareness, and increase lead generation rates. We do remarketing campaign setup and management.',
                },
                {
                  title: 'Website conversion analysis reporting',
                  answer:
                    'Conversion analysis is a critical part of any marketing strategy. By understanding the customer conversion funnel, and discovering which keywords and marketing channels are driving traffic, we are able to optimize conversion and build a top-notch strategy.',
                },
                {
                  title: 'Monthly Reports & Consultation',
                  answer: 'Our account manager meets with you/your team to discuss your campaign’s results and opportunities for improvement.',
                },
              ]}
            />
          </div>
        </div>
        <div className="hidden md:flex flex-col md:flex-row justify-center items-center mt-23">
          <p className={'text-24 md:text-28 leading-29 font-bolder text-purple'}>Need more information?</p>
          <a
            href="https://calendar.app.google/uJZkJfztLwHZcfkC7"
            target={'_blank'}
            className={'flex font-medium text-24 md:text-28 leading-29 text-green-badge items-center ml-15 mt-10 md:mt-0'}
          >
            Schedule a call
            <p className={'jello-horizontal'}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6  " fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </p>
          </a>
        </div>
      </div>
    </>
  );
}

export default content;
